/**
 * Display helpers shared by the shell pages. Pack metadata stays untouched;
 * these only change how titles, dates and default names are shown.
 */

const ORDER_PREFIX = /^\s*(\d+)\.(?!\d)\s*/;

/** "03. Wheel cradles" -> "Wheel cradles". Authors number titles to order the catalog; users shouldn't see it. */
export function displayTitle(title: string): string {
  const stripped = title.replace(ORDER_PREFIX, "");
  return stripped || title;
}

/** The ordering number of a "03. Title" style title, or undefined. */
export function titleOrder(title: string): number | undefined {
  const m = ORDER_PREFIX.exec(title);
  return m ? Number(m[1]) : undefined;
}

/** Stable sort by the authors' "NN." prefix; unprefixed titles keep their order after the numbered ones. */
export function sortByTitleOrder<T extends { title: string }>(items: T[]): T[] {
  return items
    .map((it, i) => ({ it, i, o: titleOrder(it.title) ?? Number.POSITIVE_INFINITY }))
    .sort((a, b) => a.o - b.o || a.i - b.i)
    .map((x) => x.it);
}

/** "Oct 15" this year, "Oct 15, 2025" otherwise. */
export function shortDate(iso: string, locale?: string, now = new Date()): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const sameYear = d.getFullYear() === now.getFullYear();
  return d.toLocaleDateString(locale, sameYear ? { month: "short", day: "numeric" } : { month: "short", day: "numeric", year: "numeric" });
}

/** "14:05" style time, used to tell same-day items apart. */
export function shortTime(iso: string, locale?: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
}
